<template>
  <div class="files_list">
    <div class="files_item" v-for="item in onlyImageList" :key="item.link">
      <el-image
        :src="item.link"
        class="files_image"
        :preview-src-list="previewList"
      >
        <template #error>
          <div class="files_image_error">
            <div>非图片不支持预览</div>
            <div>
              请点击<a class="font-main font-pointer" :href="item.link">下载</a>
            </div>
          </div>
        </template>
      </el-image>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageList: {
      type: Array,
      default: [],
    },
  },
  computed: {
    onlyImageList() {
      return this.imageList.filter((item) => item.fileType === 1);
    },
    previewList() {
      return this.onlyImageList.map(({ link }) => link);
    },
  },
};
</script>

<style lang="scss" scoped>
.files_list {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  .files_item {
    position: relative;
    .files_image {
      width: 150px;
      height: 80px;
    }
    :deep(.files_image_error) {
      height: 80px;
      padding: 15px 0;
      line-height: 25px;
      background: #f7f7f7;
      color: #999;
      text-align: center;
    }
  }
}
</style>
